var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.994,
    height: 54.62,
    viewBox: "0 0 61.994 54.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning-sign",
    d: "M63.18,51.45,38.08,8.6a5.889,5.889,0,0,0-10.16,0L2.82,51.45A5.885,5.885,0,0,0,7.9,60.31H58.11A5.882,5.882,0,0,0,63.18,51.45ZM33,18.93a3.826,3.826,0,0,1,3.81,4.04L35.7,41.85H30.3L29.19,22.97A3.826,3.826,0,0,1,33,18.93Zm0,35.05a4.04,4.04,0,1,1,4.04-4.04A4.042,4.042,0,0,1,33,53.98Z",
    transform: "translate(-2.003 -5.69)",
    fill: "#009fe3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/Warning-sign.dd1432d795bf9af9288576a62d24a9ef.svg";
export { ForwardRef as ReactComponent };